import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../store/global-selectors';
import { ProviderHelperService } from '../../../../services/provider-helper-service';
import { useFilteredSellerLabelProviders } from '../../../../hooks/use-filtered-seller-label-providers';
import { SimpleDropdown } from '../../../../components/simple-dropdown';
import messages from '../messages';

import { BulkActions } from '../../../../enums/bulk-actions';

const shippingAccountMessage = defineMessage({
  description: 'Bulk Update Shipping Account Label',
  defaultMessage: 'Shipping Account',
  id: 'hMVdvL',
});

const ShippingAccountDropdown = ({ onChange, model }) => {
  const sellerLabelProviders = useFilteredSellerLabelProviders();
  const providers = useSelector(Global.selectReferenceDatagetProviders);
  const onSelect = useCallback(
    (value) => {
      onChange({
        ...model,
        shippingConfiguration: {
          ...model.shippingConfiguration,
          sellerLabelProviderId: value,
        },
      });
    },
    [onChange, model],
  );
  const selectedSellerLabelProviderId = model?.shippingConfiguration?.sellerLabelProviderId;

  const getShippingAccountOptionName = useCallback(
    (sellerLabelProvider) => ProviderHelperService.getSellerLabelProviderName(sellerLabelProvider, providers, sellerLabelProviders),
    [providers, sellerLabelProviders],
  );

  const mappedShippingAccountOptions = useMemo(
    () =>
      sellerLabelProviders.map((option) => ({
        name: getShippingAccountOptionName(option),
        key: option.sellerLabelProviderId,
      })),
    [getShippingAccountOptionName, sellerLabelProviders],
  );

  return (
    <SimpleDropdown
      defaultTitle={<FormattedMessage {...messages.pleaseSelect} />}
      dropdownMenuShouldHaveWidthOfButton
      items={mappedShippingAccountOptions}
      label={<FormattedMessage {...shippingAccountMessage} />}
      onItemSelected={onSelect}
      selectedItemKey={selectedSellerLabelProviderId}
    />
  );
};

ShippingAccountDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  model: PropTypes.object.isRequired,
};

export default {
  id: BulkActions.shippingAccount.name,
  render: (onChange, model) => {
    return <ShippingAccountDropdown model={model} onChange={onChange} />;
  },
};
